import axios from "axios";
import { PublicApi } from "../api/api";

export interface UserProps {
  userId?: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  assignedTank: string;
  address: string;
  createdAt?: string;
}

export interface UserProp {
  first_name: string;
  last_name: string;
  phone_number: string;
  email: string;
  bin_id: number;
  id: number;
}

export const createUser = async (userData: UserProps) => {
  try {
    const response = await PublicApi.post("/user/create/", {
      firstName: userData.firstName,
      lastName: userData.lastName,
      phoneNumber: userData.phoneNumber,
      email: userData.email,
      address: userData.address,
      assignedTank: userData.assignedTank,
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      console.error("Error response:", error.response.data);
    }
    throw error;
  }
};

export const fetchAllUsers = async () => {
  try {
    const response = await PublicApi.get("/");
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchlUserById = async (id: number) => {
  try {
    const response = await PublicApi.get(`/users/${id}/`);
    return response;
  } catch (error) {
    throw error;
  }
};
